// The first part of the URL that namespaces PHC projects
export const basename = 'app-switcher';
